import { ReactGAImplementation } from "react-ga4";

export const reactGA = new ReactGAImplementation();

// ---- ENHANCED MEASUREMENT EVENTS ------------------
// see: https://support.google.com/analytics/answer/9216061?hl=en&ref_topic=13367566&sjid=13177187684788489307-EU

// ---- RECOMMENDED EVENTS ---------------------------
// see: https://support.google.com/analytics/answer/9267735
export function actionLogin() {
    reactGA.event( "login", {
        action: "",
        category: "",
        label: ""
    })
}

// ---- CUSTOM EVENTS --------------------------------
export function actionOrderNewsletter() {
    reactGA.event({
        action: "",
        category: "",
        label: ""
    })
}

const events = {
    login: actionLogin,
    orderNewsletter: actionOrderNewsletter,
}

export { events };
